export var ExpenseCodeEnforcementMode;
(function (ExpenseCodeEnforcementMode) {
    ExpenseCodeEnforcementMode[ExpenseCodeEnforcementMode["DEFAULT_NOT_REQUIRED"] = 0] = "DEFAULT_NOT_REQUIRED";
    ExpenseCodeEnforcementMode[ExpenseCodeEnforcementMode["OPTIONAL_CODE"] = 1] = "OPTIONAL_CODE";
    ExpenseCodeEnforcementMode[ExpenseCodeEnforcementMode["ENFORCED_CODE"] = 2] = "ENFORCED_CODE";
    ExpenseCodeEnforcementMode[ExpenseCodeEnforcementMode["ENFORCED_PATTERN"] = 3] = "ENFORCED_PATTERN";
    ExpenseCodeEnforcementMode[ExpenseCodeEnforcementMode["ENFORCED_LIST"] = 4] = "ENFORCED_LIST";
})(ExpenseCodeEnforcementMode || (ExpenseCodeEnforcementMode = {}));
export var PermittedOrderContents;
(function (PermittedOrderContents) {
    PermittedOrderContents[PermittedOrderContents["WORK_ORDER_CONTENT_UNKNOWN"] = 0] = "WORK_ORDER_CONTENT_UNKNOWN";
    PermittedOrderContents[PermittedOrderContents["WORK_ORDER_CONTENT_RESTAURANT"] = 1] = "WORK_ORDER_CONTENT_RESTAURANT";
    PermittedOrderContents[PermittedOrderContents["WORK_ORDER_CONTENT_GROCERY"] = 2] = "WORK_ORDER_CONTENT_GROCERY";
    PermittedOrderContents[PermittedOrderContents["WORK_ORDER_CONTENT_ALCOHOL"] = 3] = "WORK_ORDER_CONTENT_ALCOHOL";
})(PermittedOrderContents || (PermittedOrderContents = {}));
export var BUDGET_EMAIL_NOTIFICATION_SENT_FROM;
(function (BUDGET_EMAIL_NOTIFICATION_SENT_FROM) {
    BUDGET_EMAIL_NOTIFICATION_SENT_FROM["CREATE_BUDGET"] = "create_budget";
    BUDGET_EMAIL_NOTIFICATION_SENT_FROM["EDIT_BUDGET"] = "edit_budget";
    BUDGET_EMAIL_NOTIFICATION_SENT_FROM["BUDGET_LIST"] = "budget_list";
})(BUDGET_EMAIL_NOTIFICATION_SENT_FROM || (BUDGET_EMAIL_NOTIFICATION_SENT_FROM = {}));
